import i18next from 'i18next';

export const _T = i18next.t.bind(i18next);
